export const AUTH_TOKEN = "auth-token-omMeditasyon";
export const LINKS_PER_PAGE = 5;
export const API_URL =  "https://graphcool.univerlist.com/simple/v1/ckaz0lfdl01ty01425qbul50j";